import { Injectable } from '@angular/core';
import { IEnvironmentService } from './ienvironment.service';
import { EnvironmentConfig } from './environment-config.model';
import { UtilService } from '../util/util.service';
import { LogService } from '../log/log.service';
import { environment } from 'src/environments/environment';
//import * as _environmentConfig from '../../../environment.config.json'; //static reference
//const _environmentConfig = require('../../../environment.config.json');//static reference

@Injectable()
export class EnvironmentService implements IEnvironmentService {
  //depends on script tag in index.html which put the environment.config.json data objecton the window object

  private _utilService: UtilService;
  private _logService: LogService;
  private _environmentConfig: EnvironmentConfig = new EnvironmentConfig();

  public constructor(utilService: UtilService, logService: LogService) {
    this._utilService = utilService;
    this._logService = logService;

    this._environmentConfig.WeblinkAuthUrl = 'https://www.weblinkauth.com';
    this._environmentConfig.WebApiIsSingleInstance = false;
    this._environmentConfig.WebApiUrl = '';

    try {
      this._environmentConfig.WebApiIsSingleInstance = true;
      this._environmentConfig.WebApiUrl = environment.WebApiUrl;
      this._environmentConfig.WeblinkAuthUrl = environment.WeblinkAuthUrl;
      this._environmentConfig.PersonifyIdpDomain = environment.PersonifyIdpDomain;

      // let data: any = window['wlEnvironmentConfig'];
      // if (this._utilService.isNotNullOrUndefined(data)) {
      //   if (this._utilService.isNotNullEmptyOrWhitespace(data.WeblinkAuthUrl)) {
      //     this._environmentConfig.WeblinkAuthUrl = data.WeblinkAuthUrl;
      //   }
      //   if (this._utilService.isNotNullEmptyOrWhitespace(data.PersonifyIdpDomain)) {
      //     this._environmentConfig.PersonifyIdpDomain = data.PersonifyIdpDomain;
      //   }
      //   if (this._utilService.isNotNullOrUndefined(data.WebApiIsSingleInstance)) {
      //     if (this._utilService.isBoolean(data.WebApiIsSingleInstance.toString())) {
      //       this._environmentConfig.WebApiIsSingleInstance = this._utilService.getBoolean(data.WebApiIsSingleInstance.toString());
      //     }
      //   }
      //   if (this._utilService.isNotNullEmptyOrWhitespace(data.WebApiUrl)) {
      //     this._environmentConfig.WebApiUrl = data.WebApiUrl;
      //   }
      // } else {
      //   this._logService.log('environment', 'wlEnvironmentConfig undefined.  Using default config.');
      // }
    } catch (e) {
      this._logService.log('environment', 'error parsing environment config.  Using default config.');
    }
  }

  public getEnvironmentConfig = (): EnvironmentConfig => {
    return this._environmentConfig;
  };
}
